export default function (element, data) {
    element.querySelectorAll(".menu-link").forEach(el => function() {
        el.addEventListener("click", function (event) {
            window.dispatchEvent(new CustomEvent("pageswitch"));
        });
    })
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
